import React from "react";
import { Link, useNavigate } from "react-router-dom";
// import bannerImage from "../../../Assets/Images/Fundraising_banner.png";
import bannerImage from "../../../Assets/Images/fund-rising.png";
import LeftIcon from "../../../Assets/Icons/LeftIcon";

import "./style.css";

const Banner = () => {
  const navigate = useNavigate();
  return (
    <div className="fundraising-banner-container">
      <div className="fundraising-banner-content">
        <div className="fundraising-maxWidth-content">
          <Link onClick={() => navigate(-1)}>
            <LeftIcon />
          </Link>
          <h1>Fundraising</h1>
        </div>
      </div>
    </div>
  );
};

export default Banner;
